export const period = {
  AFTER: 'AFTER',
  BEFORE: 'BEFORE',
  CLOSED: 'CLOSED',
  CURRENT: 'CURRENT',
};
